import React, { useState } from 'react';
import { Mail, X, Send, AlertCircle, CheckCircle2 } from 'lucide-react';
import { supabase } from '../supabaseClient';
import { useNotifications } from '../context/NotificationContext';
import './VerificationModal.css';

const VerificationModal = ({ isOpen, onClose, appointment }) => {
  const [email, setEmail] = useState('');
  const [isSending, setIsSending] = useState(false);
  const { addNotification } = useNotifications();

  if (!isOpen || !appointment) return null;

  const handleSend = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsSending(true);
    try {
      // Call the Edge Function to send the real email
      const { data: { session } } = await supabase.auth.getSession();
      const token = session?.access_token ?? '';

      const res = await fetch(
        'https://xblhgnuxsetxribyhxkc.supabase.co/functions/v1/send-verification-email',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token || 'sb_publishable_nHbxC3fnRadWGQwGUeFYAA_ePsCAxLy'}`
          },
          body: JSON.stringify({ appointment, targetEmail: email })
        }
      );

      if (!res.ok) throw new Error('Edge function error');

      addNotification({
        title: 'Verificación Enviada',
        message: `Legajo de ${appointment.patient_name} enviado a ${email}.`,
        type: 'success'
      });

      onClose();
    } catch (err) {
      console.error('Error sending verification:', err);
      addNotification({
        title: 'Error',
        message: 'No se pudo procesar el envío. Verificá tu conexión.',
        type: 'error'
      });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="verification-modal-overlay">
      <div className="verification-modal card">
        <div className="v-modal-header">
          <div className="v-title">
            <Mail className="v-icon" size={20} />
            <h3>Verificar Legajo de Paciente</h3>
          </div>
          <button className="close-btn" onClick={onClose}><X size={20} /></button>
        </div>

        <div className="v-modal-body">
          <div className="patient-summary-box">
            <p><strong>Paciente:</strong> {appointment.patient_name}</p>
            <p><strong>Estudio:</strong> {appointment.study_type}</p>
            <p><strong>Fecha/Hora:</strong> {appointment.appointment_date} {appointment.appointment_time}</p>
          </div>

          <p className="v-description">
            Se enviará un correo con toda la información cargada por el paciente (datos personales, notas médicas y archivos) al consultorio o sucursal seleccionada.
          </p>

          <form onSubmit={handleSend} className="v-form">
            <div className="form-group">
              <label>Correo electrónico del destinatario</label>
              <input 
                type="email" 
                placeholder="ejemplo@consultorio.com" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>

            <div className="v-info-alert">
              <AlertCircle size={16} />
              <span>El destinatario podrá confirmar o rechazar el legajo directamente desde el correo.</span>
            </div>

            <div className="v-actions">
              <button type="button" className="btn-secondary" onClick={onClose}>Cancelar</button>
              <button type="submit" className="btn-primary" disabled={isSending}>
                {isSending ? 'Enviando...' : <><Send size={18} /> Enviar Legajo</>}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default VerificationModal;
